<div class="flex flex-col w-full pt-28">
        <div>
                @if (view.type === 'flight') {
                        <flight-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged()"></flight-list>
                }
                @if (view.type === 'hotel') {
                        <stay-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged()"></stay-list>    
                }
                @if (view.type === 'package') {
                        <div *ngIf="view.search && view.trip" class="hidden">
                                <flight-list [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event)"></flight-list>
                                <flight-list [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event)"></flight-list>

                                <!-- Airport to resort -->
                                <transfer-list *ngIf="view.search && view.search.flights" [options]="view.search" [trip]="view.trip" [point]="view.trip.points[2]" [pointTo]="view.trip.points[1]" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event, 0)"></transfer-list>
                                <!-- Resort to airport -->
                                <transfer-list *ngIf="view.search && view.search.flights" [options]="view.search" [trip]="view.trip" [point]="view.trip.points[1]" [pointTo]="view.trip.points[2]" [cacheMode]="view.cacheMode" (resultChange)="resultChanged($event, 1)"></transfer-list>
                        </div>
                        <stay-list *ngIf="view.search && view.trip && view.search.flights && view.search.transfers && view.transfersReceived == 2" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" [displayMode]="'list'" (resultChange)="resultChanged($event)"></stay-list>
                }
                @if (view.type === 'car') {
                        <car-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged()"></car-list>
                }
                @if (view.type === 'transfer') {
                        <transfer-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged()"></transfer-list>
                }
                @if (view.type === 'activity') {
                        <activity-list *ngIf="view.search && view.trip" [options]="view.search" [trip]="view.trip" [cacheMode]="view.cacheMode" (resultChange)="resultChanged()"></activity-list>
                }
        </div>
        <div>
                <!-- <app-destination-list-type01></app-destination-list-type01> -->
        </div>

</div>


